import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Auth.css";
import { setAuthSession } from "../services/api";

export default function RegisterPage() {
  const [role, setRole] = useState("siswa");
  const [inviteCode, setInviteCode] = useState("");
  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [namaSekolah, setNamaSekolah] = useState("");
  const [kelas, setKelas] = useState("");
  const [tanggalLahir, setTanggalLahir] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  

  const handleRegister = async (e) => {
    e.preventDefault();
    const body = {
      nama,
      email,
      password,
      role,
      inviteCode: role === "guru" ? inviteCode : undefined,
      namaSekolah: role === "siswa" ? namaSekolah : undefined,
      kelas: role === "siswa" ? kelas : undefined,
      tanggalLahir: role === "siswa" ? tanggalLahir : undefined,
    };

    try {
      const res = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();

      if (res.ok) {
        setAuthSession({
          token: data.token,
          refreshToken: data.refreshToken,
          user: data.user,
        });
        navigate("/");
      } else {
        setMessage(data.message || "Registrasi gagal");
      }
    } catch (err) {
      setMessage("Terjadi kesalahan server");
    }
  };

  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleRegister}
        className="bg-white p-8 rounded-2xl shadow-lg w-96 space-y-4"
      >
        <h2 className="text-2xl font-bold text-center text-green-600">Daftar</h2>

        {message && <p className="text-red-500 text-center" role="alert">{message}</p>}

        <label htmlFor="register-role" className="auth-label">Peran</label>
        <select
          id="register-role"
          className="w-full p-2 border rounded-lg"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="siswa">Siswa</option>
          <option value="guru">Guru</option>
        </select>

        <label htmlFor="register-nama" className="auth-label">Nama Lengkap</label>
        <input
          id="register-nama"
          type="text"
          placeholder="Nama Lengkap"
          className="w-full p-2 border rounded-lg"
          value={nama}
          onChange={(e) => setNama(e.target.value)}
          required
          autoComplete="name"
        />

        <label htmlFor="register-email" className="auth-label">Email</label>
        <input
          id="register-email"
          type="email"
          placeholder="Email"
          className="w-full p-2 border rounded-lg"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />

        <label htmlFor="register-password" className="auth-label">Password</label>
        <div className="relative">
          <input
            id="register-password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="w-full p-2 pr-10 border rounded-lg"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-gray-800 cursor-pointer"
            aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
          >
            <span aria-hidden="true">{showPassword ? "👁️" : "👁️‍🗨️"}</span>
          </button>
        </div>

        {role === "guru" && (
          <>
            <label htmlFor="register-invite" className="auth-label">Kode undangan guru</label>
            <input
              id="register-invite"
              type="text"
              placeholder="Kode undangan guru"
              className="w-full p-2 border rounded-lg"
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value)}
              required
            />
          </>
        )}

        {role === "siswa" && (
          <>
            <label htmlFor="register-sekolah" className="auth-label">Nama Sekolah</label>
            <input
              id="register-sekolah"
              type="text"
              placeholder="Nama Sekolah"
              className="w-full p-2 border rounded-lg"
              value={namaSekolah}
              onChange={(e) => setNamaSekolah(e.target.value)}
            />
            <label htmlFor="register-kelas" className="auth-label">Kelas</label>
            <input
              id="register-kelas"
              type="text"
              placeholder="Kelas"
              className="w-full p-2 border rounded-lg"
              value={kelas}
              onChange={(e) => setKelas(e.target.value)}
            />
            <label htmlFor="register-tgl" className="auth-label">Tanggal Lahir</label>
            <input
              id="register-tgl"
              type="date"
              className="w-full p-2 border rounded-lg"
              value={tanggalLahir}
              onChange={(e) => setTanggalLahir(e.target.value)}
            />
          </>
        )}

        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700"
        >
          Daftar
        </button>

        <p className="text-center text-sm">
          Sudah punya akun?{" "}
          <Link to="/login" className="text-green-500 hover:underline">
            Login
          </Link>
        </p>
      </form>
    </div>
  );
}
